import axios from 'axios';
import store from '@/store';

const instance = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
});

instance.interceptors.request.use((config: any) => {
  const token = store.getters['token'];
  config.headers.common['Accept-Language'] = 'pl';

  if (token) {
    config.headers.common['key'] = token;
  } else {
    delete config.headers.common['key'];
  }

  return config;
});

//handle api errors
instance.interceptors.response.use(
  response => response,
  error => {
    if (error.response.status === 404) {
      console.log('error'); //to do toast
    }
    return Promise.reject(error);
  }
);

export default instance;
